import {MarkerClusterer} from "@googlemaps/markerclusterer";

let map;
let markerCluster;
let markers = [];
let previousMarkerData = "";

export async function initMapOnlyMap(markerData, onlyUpdateMarkers = false) {
  if (map && onlyUpdateMarkers) {
    updateMarkers(markerData);
    return;
  }

  const delhi = {lat: 28.6139, lng: 77.209};
  let position = markerData?.length ? markerData[0].position : delhi;

  //@ts-ignore
  const {Map} = await google.maps.importLibrary("maps");

  if (!map) {
    map = new Map(document.getElementById("map-container"), {
      zoom: 18,
      center: position,
      mapId: "DEMO_MAP_ID",
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
    });
  }

  updateMarkers(markerData);
}

function updateMarkers(markerData) {
  const markerDataString = JSON.stringify(markerData);

  if (markerDataString === previousMarkerData) {
    console.log("No changes in marker data, skipping update.");
    return;
  }

  previousMarkerData = markerDataString;

  // Remove existing markers
  markers.forEach((marker) => marker.setMap(null));
  markers = [];

  let bounds = new google.maps.LatLngBounds();

  markerData.forEach((markerInfo) => {
    const marker = new google.maps.Marker({
      position: markerInfo.position,
      icon: markerInfo.icon,
      map: map,
    });
    markers.push(marker);
    bounds.extend(marker.position);
  });

  if (markerData.length > 1) {
    map.fitBounds(bounds);
  } else if (markerData.length === 0) {
    map.setZoom(5);
  }

  if (markerCluster) {
    markerCluster.clearMarkers();
  }

  // Ensure MarkerClusterer is properly initialized
  markerCluster = new MarkerClusterer({markers, map});

  console.log("Markers updated!");
}
